/* eslint no-unused-vars : "off" */
import React from "react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as axios from "./server-interceptor";
import { renderReactNode } from "./utils/reactRoot";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./global/styles/globalMagneticStyle.less";

if (window.top !== window.self) {
  window.parent.location = window.self.location;
}

renderReactNode(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
